import React, { useContext, useEffect } from 'react';
import { getName } from '../../../../../../utils/treeVisitors/helpers';
import { useTempRecords } from '../../../../../customHooks/react-use-temp-records';
import { useMenu } from '../../../../../customHooks/useMenu';
import { CategoryLink } from '../../../CategoryLink';
import { StoreContext } from '../../../../../appContext/StoreProvider';
import { TreeNavigationMenu } from '../../../TreeMenus/TreeNavigationMenu';
import { getShouldShowPimple } from '../../../utils';
import style from '../ArticlesSections.scss';
import { focusFirstItemArticle } from '../utils';

export const ArticleCategoriesLinks = ({ menuSync, validateActiveLink }) => {
  const { store } = useContext(StoreContext);

  const { addRecord, hasRecords } = useTempRecords(500);
  const { toggleTreeNavigationMenu, toggleMenuKeys, openedKeys } =
    useMenu(true);

  useEffect(() => {
    menuSync(`${window.location.pathname}${window.location.hash}`);
  }, []);

  return Object.keys(store.guidesTree).map((key, i) => {
    const currentTree = store.guidesTree[key];
    if (currentTree && currentTree.data) {
      const title = getName(currentTree.data);

      const articlesWithShouldShowChangelog =
        currentTree.data.relatedGuides &&
        currentTree.data.relatedGuides.map((article) => {
          const { isChangelog, content, link } = article;
          const shouldShowPimple = getShouldShowPimple(
            store,
            isChangelog,
            content,
            link,
            validateActiveLink(link),
          );

          return shouldShowPimple
            ? { ...article, shouldShowPimple: true }
            : article;
        });

      const shouldShowPimpleInCategory = articlesWithShouldShowChangelog.some(
        (article) => article.shouldShowPimple,
      );

      const isExpanded = openedKeys.includes(key);

      const toggleCategory = () => {
        toggleTreeNavigationMenu(key);
        toggleMenuKeys(key);
      };

      const onCategoryLinkClick = () => {
        toggleCategory();
        focusFirstItemArticle(store, i);
      };

      return (
        <section
          data-hook={`${title}-top-level-guides-section`}
          key={title}
          className={style.menuSection}
          data-section={`markdown-menu-section-${i}`}
        >
          <CategoryLink
            isExpanded={isExpanded}
            title={getName(currentTree.data)}
            link={currentTree.data.urlFormat}
            onLinkClick={onCategoryLinkClick}
            onExpandButtonClick={toggleCategory}
            type="markdown"
            shouldShowPimple={shouldShowPimpleInCategory}
          />
          {isExpanded && (
            <TreeNavigationMenu
              hasBeenClickedRecently={hasRecords}
              markAsRecentlyClicked={addRecord}
              key={key}
              treeKey={key}
              tree={currentTree}
              treeDepth={0}
              prefix={currentTree.data.urlFormat}
              menuSync={menuSync}
            />
          )}
        </section>
      );
    }
    return null;
  });
};
